<template>
  <div class="w-full bigContainer">
    <div class="pt-4">
      <h2> {{ $t('message.linkUser.title') }}</h2>
      <div v-if="!verification"> 
      <div class="container">
       <Title :step="step" :linkUserDataFormArray="linkUserDataFormArray" />
        <div>
          <div class="flex justify-between items-center px-4">
          </div>
          <div class="py-4">
          <step-init v-if="step === 0" :linkUserDataFormArray="linkUserDataFormArray" :step="step" />
          <step-linking ref="linkingStep" v-else-if="step <= linkUserDataFormArray.length" :linkUserDataFormArray="linkUserDataFormArray" :step="step" :warning="warning" @notLinkAccount="handleNotLinkAccount" />
          <step-finish ref="finishStep" v-else :accountsToLink="accountsToLink" :step="step" :executeLinkingError="executeLinkingError"  :isMobile="isMobile" />

          </div>
        </div>
      </div>
      <div class="footer">
        <zt-button color="disabled" style="color: #707070 !important" class="mr-1" data-vs-button="cancel" @click="cancelModalActive = !cancelModalActive">
          {{ $t('message.linkUser.cancelBtn') }}
        </zt-button>
        <zt-button v-if="step <= linkUserDataFormArray.length" data-vs-button="save" @click="stepForward"> {{ $t('message.linkUser.nextButton') }} </zt-button>
        <zt-button v-else data-vs-button="save" @click="linkUserAccount()"> {{ $t('message.linkUser.linkAccountBtn') }} </zt-button>
      </div>
    </div>
    <div v-if="verification">

      <div  class="container">
        <Title :step="step" :linkUserDataFormArray="linkUserDataFormArray" />
          <StepVerification 
          ref="verificationStep" 
          :verificationCodeSent="verificationCodeSent" 
          :step="step" 
          :linkUserDataFormArray="linkUserDataFormArray"
          :mfaError="mfaError"
          @handleNotLinkAccount="handleNotLinkAccount" 
          :toEmail="toEmail" />
        
      </div>

      <div class="footer">
        <zt-button color="disabled" style="color: #707070 !important" class="mr-1" data-vs-button="cancel" @click="cancelModalActive = !cancelModalActive">
          {{ $t('message.linkUser.cancelBtn') }}
        </zt-button>
       
        <zt-button  data-vs-button="save" @click="verificationForward"> Enviar </zt-button>
      </div>
    </div>
  </div>
    <cancel-link-user-modal 
      :cancelModalActive="cancelModalActive"
      :isMobile="isMobile"
      @update:cancelModalActive="cancelModalActive = $event"
    />
    <confirm-link-user-modal 
      :confirmModalActive="confirmModalActive"
      :isMobile="isMobile"
      @update:confirmModalActive="confirmModalActive = $event" />
    <success-linking-modal 
      :isMobile="isMobile"
      :successModalActive="successModalActive"
      @update:successModalActive="successModalActive = $event" 
      />
  </div>
</template>

<script>
import logoCompany from '@/components/commons/LogoCompany'
import CancelLinkUserModal from '../components/CancelLinkUserModal.vue';
import ConfirmLinkUserModal from '../components/ConfirmLinkUserModal.vue';
import { useWindowResize } from '@sichern/ui-elements' 
import StepInit from '../components/StepInit.vue';
import StepLinking from '../components/StepLinking.vue';
import StepFinish from '../components/StepFinish.vue';
import Title from '../components/Title.vue';
import StepVerification from '../components/StepVerification.vue';
import UsersLink from '@/apiClient/UsersLink';
import SuccessLinkingModal from '../components/SuccessLinkingModal.vue';
import { mapActions } from 'vuex';


export default {
  components: {
    logoCompany,
    ConfirmLinkUserModal,
    CancelLinkUserModal,
    StepInit,
    StepLinking,
    StepFinish,
    Title,
    StepVerification,
    SuccessLinkingModal
  },
  data() {
    return {
      windowResize: useWindowResize(this),
      step: 0,
      linkUserData: this.$store.state.linkUserMergeCandidates,
      noLinkAccountModalActive:false,
      cancelModalActive:false,
      confirmModalActive:false,
      linkUserDataFormArray: [],
      password:'',
      verification: false,
      verificationCodeSent: false,
      warning:'',
      accountsNotToLink: [],
      accountsToLink: [],
      toEmail: '',
      mfaError: '',
      executeLinkingError: '',
      successModalActive: false
    }
  },
    created() {
      this.usersLink = new UsersLink()
      if (this.linkUserData.length > 0) {
    this.linkUserDataFormArray = [...this.linkUserData];
  } else {
    this.usersLink
      .checkUsersLink()
      .then(res => {
        const data = res.data;
        this.setLinkUserMergeCandidates(data.candidates);
        this.linkUserDataFormArray = [...data.candidates];
        this.linkUsersModalActive = !data.notify_later;
        this.notifications = data.notify_later;
      })
      .catch(err => {
        // Handle USER_LINK_NOT_FOUND or other errors
        if (err.response && err.response.data && err.response.data.codes) {
          const errorCodes = err.response.data.codes
          const userLinkNotFound = errorCodes.some(code => code.code === 'USER_LINK_NOT_FOUND')
          
          if (userLinkNotFound) {
            // No users found to relate, reset the state
            this.setLinkUserMergeCandidates([])
            this.linkUserDataFormArray = []
            this.linkUsersModalActive = false
            this.notifications = false
          }
        }
        console.error('Error checking users link:', err)
      })
      }
    },
  computed: {
    isMobile() {
      return this.windowResize.width < 1024
    },
    logoId() {
      const logosIds = this.linkUserDataFormArray.map((company) => parseInt(company.companyId))
      return logosIds
    }
  },
  methods: {
    ...mapActions(['setLinkUserMergeCandidates']),
    async linkUserAccount() {
      const data = {
        accounts:JSON.stringify(this.accountsToLink),
       // accountsNotToLink: this.accountsNotToLink,
        email: this.$refs.finishStep.email,
        password: this.$refs.finishStep.password
      }
      const isValidEmail = this.$refs.finishStep.isValidEmail
          if (isValidEmail) {
      try {
        await this.usersLink.executeLinking(data)
        this.successModalActive = true
      } catch (error) {
        this.executeLinkingError = error.response.data.codes[0].code
      }
    }
    },
    badgeColor() {

      return this.step > linkUserDataFormArray.length ? '#379579' : 'grey'
    },
    async stepForward() {

      if (this.step > 0) {
        let pass = this.$refs.linkingStep.password
        let userId = this.linkUserDataFormArray[this.step - 1].userId

        if (this.warning === 'USER_LINK_LAST_ATTEMPT_FAILED') {
          this.handleNotLinkAccount(userId,3)
          return
        }

        try {
          this.warning = ''
          const response = await this.usersLink.checkCandidateCredentials(userId, pass)
          this.verification = true
          this.verificationCodeSent = response.data.data.verificationCodeSent
          this.toEmail = response.data.data.toEmail
        }
        catch (error) {
          if (error.response.data.codes[0].code) {
            this.warning = error.response.data.codes[0].code
          }
          else {
            this.warning = '00017'
          }
        }

      }

      else this.step++
    },
    handleNotLinkAccount(userId, reasons) {
      this.accountsNotToLink.push({
        userId: userId,
        reason: reasons
      })
      if (reasons !== 3) {
        this.usersLink.excludeCandidate(userId, reasons)
      }
      this.warning= ''
      this.step++ 
    },
  async verificationForward() {
     if (this.verificationCodeSent) {
      try {
        this.mfaError= ''
        let mfaVal = this.$refs.verificationStep.inputs.map(input => input.value).join('')
        const userId = this.linkUserDataFormArray[this.step - 1].userId
        await this.usersLink.postValidationCode(userId, mfaVal)
        this.accountsToLink.push(userId)
        this.verification = false
        this.verificationCodeSent = false
        this.step++
      }
      catch(error) {
        this.mfaError = error.response.data.codes[0].code
        const initialValue = { value: "" };
        this.$refs.verificationStep.inputs = Array.from({ length: 6 }, () => ({ ...initialValue }));
      }
      
  
        
      }
      else {
       try {
          const userId = this.linkUserDataFormArray[this.step - 1].userId
          this.toEmail = this.$refs.verificationStep.email
          const isValidEmail = this.$refs.verificationStep.isValidEmail
          if (isValidEmail) {
            const response = await this.usersLink.reSendValidationCode(userId, this.toEmail)
            this.verificationCodeSent = response.data.data.verificationCodeSent
          } else {
            return
          }
        } catch (error) {
        }
      }

    
  },
}

}
</script>

<style lang="scss" scoped>
.bigContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .container {
    padding: 56px 80px 20px 80px;
    max-width: 660px;
    min-width: 460px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
    border-radius: 5px 5px 0px 0px;

    h1 {
      font-style: normal;
      font-weight: 700;
      font-size: 24px;
      line-height: 28px;
      color: #2d2d2d;
    }
  }

  h2 {
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 28px;
    color: #707070;
    padding-bottom: 20px;
  }

  .footer {
    text-align: right;
    padding: 17px 24px;
    width: 100%;
    background: #ebebeb;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.15);
    border-radius: 0px 0px 5px 5px;
  }

  .step {
    width: 24px;
    height: 24px;
    border: 2px solid #d1d5db;
    /* Gris para pasos pendientes */
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
  }

  .completed {
    background-color: #34d399;
    /* Verde para pasos completados */
    border-color: #34d399;
    color: white;
  }

  .pending {
    background-color: #fbbf24;
    /* Azul para paso pendiente */
    border-color: #fbbf24;
    color: white;
  }
  .logo-company-change-box{ 
    max-width: 100px;
  }
  @media (max-width: 600px) {
    .container {
      padding: 26px 40px 20px 20px;
    }
  }
}
</style>
